import React from 'react';
import CombinedStatsDonut from './CombinedStatsDonut';
import StatsOverTime from './StatsOverTime';

export interface CombinedStatsProps {
  getData: () => Promise<unknown>;
  getAuthorisedData?: () => Promise<unknown>;
  getUploadedData?: () => Promise<unknown>;
  stats: unknown[];
  heatmapOnClick?: (value: unknown) => void;
  heatmapOnAuthorisedClick?: (value: unknown) => void;
  heatmapOnUploadedClick?: (value: unknown) => void;
  setModeStorageKey: string;
  id?: string;
  mode?: string;
}

const CombinedStats = ({
  getData,
  getAuthorisedData,
  getUploadedData,
  stats,
  heatmapOnClick,
  heatmapOnAuthorisedClick,
  heatmapOnUploadedClick,
  setModeStorageKey,
  id,
  mode,
}: CombinedStatsProps) => {
  return (
    <div className="d-flex overflow-hidden flex-column flex-xl-row">
      <CombinedStatsDonut stats={stats} />
      <StatsOverTime
        getData={getData}
        getAuthorisedData={getAuthorisedData}
        getUploadedData={getUploadedData}
        onClick={heatmapOnClick}
        onAuthorisedClick={heatmapOnAuthorisedClick}
        onUploadedClick={heatmapOnUploadedClick}
        setModeStorageKey={setModeStorageKey}
        id={id}
        mode={mode}
      />
    </div>
  );
};

export default CombinedStats;
